import { useContext, useEffect, useMemo, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { ToastContext } from "../../../context/ToastContext";
import { calculateWordsFromString } from "../../../utils/Helper";

export const useLog = ({ projectOpts, setShowRequestPopup, callApi, editData }) => {

    const { showInfo, showSuccess ,showError} = useContext(ToastContext)
    const [logRequestData, setLogRequestData] = useState({});
    const [previousData, setPreviousData] = useState(null)
    const [options, setOptions] = useState({
        env: [],
        log: []
    });
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        if (editData !== undefined && editData !== null) {
            const projectId = _.findWhere(projectOpts, { project_id: editData?.project_id })
            const data = {
                "logs_request_id": editData?.log_request_id,
                "project_id": projectId,
                "reason": editData?.reason,
                "approver_user_code": editData?.approver_user_code,
                "env_type": editData?.log_environment_id,
                "logType": _.filter(options.logOptions, { log_type_id: editData?.log_type_id })
            }
            setLogRequestData(data);
            setPreviousData(data);
        } else {
            setLogRequestData({ logs_request_id: 0, });
        }
    }, [editData, options.logOptions])

    useEffect(() => {
        callautopopulate('log_environments', "log_type").then((res) => {
            setOptions({ envOptions: res?.log_environments, logOptions: res?.log_type })
        })
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLogRequestData((prev) => ({ ...prev, [name]: value }))
    }

    // this function handle add or edit 
    const logRequestUpsert = async () => {

        try {
            if (_.isEqual(logRequestData, previousData)) {
                showInfo("info", "No changes made");
                return;
            }
            if (!logRequestData?.project_id) {
                showInfo("info", "Please select project.");
                return;
            }
            if (!logRequestData?.env_type) {
                showInfo("info", "Please select an env.");
                return;
            }
            if (!logRequestData?.logType) {
                showInfo("info", "Please select log type.");
                return;
            }
            if (logRequestData?.approver_user_code === undefined || logRequestData?.approver_user_code === 0) {
                showInfo("info", "Please select an approver.");
                return;
            }
            if ((logRequestData.reason && calculateWordsFromString(logRequestData.reason) < 5) || !logRequestData.reason) {
                showInfo("info", "Reason should contain minimum 5 words.");
                return;
            }
            setLoader(true)
            const payload = {
                "logs_request_id": logRequestData?.logs_request_id || 0,
                "project_id": logRequestData?.project_id?.project_id,
                "log_environment_id": parseInt(logRequestData?.env_type),
                "log_type_ids": _.pluck(logRequestData?.logType, "log_type_id").toString(),
                "reason": logRequestData.reason,
                "approver_user_code": logRequestData?.approver_user_code
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTLOGSRIGHTSREQUEST"), payload);
            if (res?.status === 200) {
                setLoader(false)
                callApi();
                setShowRequestPopup(false);
                showSuccess("success", res.body.message)
            }
        } catch (error) {
            setLoader(false)
            console.error("Error:", error);
            showError("Error", error?.response?.data?.errorMessage);
        }

    }
    useEffect(() => {
        if (logRequestData?.project_id?.project_id) {
            getApproverType()
        }
    }, [logRequestData?.project_id]);

    const getApproverType = async () => {

        const payload = {
            "project_id": logRequestData?.project_id?.project_id,
            "environment_id": 0,
            "jenkins_type_id": 0,
            "jenkins_sub_type_id": 0,
        }
        try {
            const res = await services.getInvokeRemote("POST", Urls("GETJENKINSENVTYPE"), payload);
            if (res?.status === 200) {
                setOptions((prev) => ({
                    ...prev,
                    approverOption: res?.body?.data?.jenkins_approver_list
                }))
            }
        } catch (error) {
            console.error("Error:", error);
        }
    }

    const handleEvent = (value, type) => {
        setLogRequestData((prev) => ({ ...prev, [type]: [] }))
    }

    return useMemo(() => ({
        logRequestData, handleChange, logRequestUpsert, options, handleEvent, loader
    }), [logRequestData, handleChange, logRequestUpsert, options, handleEvent, loader])
} 